<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Create"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <form-group label="Select Part">
              <v-select
                label="part"
                :options="parts"
                :filterable="false"
                @search="getParts"
                v-model="selectedPart"
              >
                <template slot="no-options">
                  Type to search parts
                </template>
                <template slot="option" slot-scope="c">
                  <div v-if="c">
                    {{ c.code }} {{ c.description }} 
                  </div>
                </template>
                <template slot="selected-option" slot-scope="c">
                    <div v-if="c">
                  {{ c.code }} {{ c.description }}
                  </div>
                </template>
              </v-select>

              <small v-if="$v.selectedPart.$error" class="text-danger">
                Please select part
              </small>
            </form-group>

           
            <form-group label="Quantity" :required="true">

                <b-form-spinbutton
                  class="form-control"
                  type="number"
                  min="1"
                  v-model="credit.quantity"
                />

                <small v-if="$v.credit.quantity.$error" class="text-danger">
                Please select quantity
              </small>
            
            </form-group>

            <form-group label="Reference">
              <input
                type="text"               
                class="form-control"
                v-model="credit.reference"
              />
            </form-group>

             <small v-if="$v.credit.reference.$error" class="text-danger">
                Please enter reference
              </small>

          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import partRepo from "@/api/repos/partRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";

export default {
  
  components: {
    formBase,
    formGroup,
  },

  validations: {
    selectedPart: {
      required,
    },
    credit: {
      quantity: {
        required,
      },
      reference: {
        required,
      },
   
    },
  },

  mounted() {
    
  },

  data() {
    return {
      parts: [],
      selectedPart: {},
      searchActivated:false,
      paymentTypes: [],
      credit: {},
      loading: false,
      errors: null,
      submitStatus: null,
    };
  },

  methods: {
    getParts(search) {
      this.searchActivated=true
      if (search.length > 1) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => {
          this.partSearch(search);
        }, 500);
      }
    },

    async partSearch(search) {
      try {
        let { data } = await partRepo.getParts(search);
        this.parts = data.parts;
        
      } finally {
        this.loading = false;
      }
    },
   
    
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";

      this.credit.part_id = this.selectedPart.id
     
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          
        await partRepo.creditCreate(this.credit);
         
         this.$root.$bvToast.toast("Success", {
            title: "Credit Added",
            autoHideDelay: 3000,
            variant: "success",
          });

        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.$v.$reset()
          this.credit = {};
          this.selectedPart = null;
          this.loading = false;
          this.submitStatus = null;
          
        }
      }
    },
  },
};
</script>

<style></style>
